import React, { useEffect, useState } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const imageUrls = [
  'images/formulario.png',
];

const getRandomImage = () => {
  const randomIndex = Math.floor(Math.random() * imageUrls.length);
  return imageUrls[randomIndex];
};

// Textos e dados do formulário como constantes
const textData = {
  Titulo: 'FÁCIL, RÁPIDA E SEM BUROCRACIA',
  Texto: 'Carro, Moto e Caminhão. Até 100% da tabela FIPE',
  TextoBotao: 'Cotação Online'
};

const Cotacao = () => {
  const [currentImage, setCurrentImage] = useState('');

  useEffect(() => {
    setCurrentImage(getRandomImage());
  }, []);

  return (
    <div id="cotacao-online" 
      className="mx-auto px-5 overflow-x-hidden"
      style={{
        backgroundImage: `url(${definicoescliente?.Cotacao?.Imagem || currentImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '400px',
      }}>
      <section className="flex items-center h-full p-4">
        {/* Seção do texto */}
        <div className="text-center mx-auto">
          <h1 className="text-textotituloprincipal font-bold text-theme-white">
            {definicoescliente?.Cotacao?.Titulo ||textData.Titulo}
          </h1>
          <p className="lg:text-textotitulo mt-4 text-theme-white">
            {definicoescliente?.Cotacao?.Descricao ||textData.Texto}
          </p>
          <button type="submit" className="md:mt-6 w-full max-w-[200px] uppercase text-textopadrao bg-theme-primary px-4 py-2 text-theme-light-primary rounded shadow-md hover:filter hover:brightness-90 border-2 border-transparent cursor-pointer transition duration-200">
              <a href={definicoescliente.Cotacao.LinkBotao || textData.TextoBotao} target="_blank" rel="noopener noreferrer">
                {definicoescliente.Cotacao.NomeBotao || textData.TextoBotao}
              </a>
          </button>
        </div>
      </section>
    </div>
  );
};

export default Cotacao;
